import React from 'react';
import { deleteDoc } from 'firebase/firestore';
import toast from 'react-hot-toast';
import { getDocumentReference, isCollectionEmpty } from 'services';

import { MODAL_TYPES, useGlobalModalContext } from '../../../../context/GlobalModal';
import { Button } from '../../../../shared/Components';
import { strings } from '../../../../strings';

export interface CollectionProps {
  collectionId: string;
  name?: string;
}

function DeleteCollectionButton(props: CollectionProps) {
  const { showModal } = useGlobalModalContext();

  const showDialogModal = () => {
    showModal(MODAL_TYPES.DIALOG_MODAL, {
      title: strings.deleteCollection,
      text: strings.formatString(strings.confirmDeleteCollection, props.name ?? 'this'),
      cancelButtonText: strings.cancel,
      submitButtonText: strings.deleteBtnCollection,
      onSubmit: () => deleteCollection(),
    });
  };

  const deleteCollection = async () => {
    if (!(await isCollectionEmpty(props.collectionId))) {
      toast.error('Cannot delete: Collection is not empty.');
      return;
    }

    const collectionRef = getDocumentReference(`collections/${props.collectionId}`);

    try {
      await deleteDoc(collectionRef);
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong deleting collection');
    }

    toast.success(`Collection ${props.name} deleted.`);
  };

  return (
    <Button variant="danger" height={30} width={100} onClick={showDialogModal}>
      {strings.delete}
    </Button>
  );
}

export default DeleteCollectionButton;
